export default __webpack_public_path__ + "static/media/logo_people.b23a036d.png";